import { render, staticRenderFns } from "./ReportFristTotal.vue?vue&type=template&id=0c86993a&"
import script from "./ReportFristTotal.vue?vue&type=script&lang=js&"
export * from "./ReportFristTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports